import {CircularProgress, Grid} from '@mui/material'
import {useDispatch, useSelector} from 'react-redux'
import {selectedTab} from '../../../../../store/prospectSegment/selectedProspectsTab/selectedProspectsTabSlice'
import SegmentProspects from '../../../../../configs/prospectsSegmentTabList.json'
import {setCampaignView} from '../../../../../store/selectedView/campaignView/campaignViewIndex'
import TableComponent from '../../../../Common/TableComponent/TableComponentIndex'
import SearchPanel from '../../../../Common/SearchPanel/SearchPanelIndex'
import {
  getSavedProspectsPageNumber,
  setAllConstituentsSavedProspectsListPageNumber
} from '../../../../../store/pagination/pageNumberSlice'
import {
  setAllConstituentsFilters,
  setAllConstituentsTotalCount
} from '../../../../../store/prospectSegment/openSavedProspect/openSavedProspectSlice'
import {useCallback, useEffect, useState} from 'react'
import headers from '../../../../../configs/allConstituentsTableHeader.json'
import useSavedConstituents from '../../../../../api/getSavedConstituents'
import prospectsActions from '../../../../../configs/prospectsAction.json'
import {StyledAlertSnackbar, StyledBox, StyledGrid, StyledSaveAndGenerateButton, StyledSnackbar} from '../../Styles'
import {useDeleteConstituentFromSavedList} from '../../../../../api/deleteProspectFromList'
import paginationLimit from '../../../../../configs/paginationLimit.json'
import {
  constituentIdList,
  setListDescription
} from '../../../../../store/prospectSegment/savedProspectsList/saveProspectsListSlice'
import {
  StyledBackButton,
  StyledBackdrop,
  StyledDiv
} from '../../AllProspects/AddToSavedProspects/AddToSavedProspectsStyles'
import {updatedSavedProspectsSearchTerm} from '../../../../../store/search/searchSlice'
import {Title} from '../../AllProspects/AddToSavedProspects/AddToSavedProspectsIndex'
import {
  getAllSavedProspectsData,
  setSortColumn,
  setSortConfig,
  setSortDirection
} from '../../../../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import {StyledAlertGrid, StyledDivContainer} from './AllConstituentsStyles'
import useUserPreferenceProspectsColumn from '../../../../../api/getUserPreferencesProspectColumns'
import {getDefaultColumns} from '../../../../../store/prospectSegment/addTableColumn/addTableColumnSlice'
import AddColumn from '../../../../Common/AddColumn'
import AlertErrorComponent from '../../../../Common/Error/Alert/AlertComponent'
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopupIndex'
import {setCampaignAction} from '../../../../../store/selectedView/campaignView/campaignActionSlice'
import {setButtonViewName, setFilters, setSwitchFilters} from '../../../../../store/askGivePrism/askGivePrismSlice'
import {
  setChatbotData,
  setInterestTagId,
  setMatchedProspectId,
  setMatchedProspectList,
  setMessage
} from '../../../../../store/askGivePrism/chatbot/chatbotStreamSlice'
import {getClassYear, getUniqueCollegeAndDegree} from '../../AllProspects/helpers'
import ExportListIndex from '../../AllProspects/ExportList/ExportListIndex'
import {clearExportError, hideExportingInfo} from '../../../../../store/prospectSegment/exportList/exportListSlice'

const AllConstituents = () => {
  const dispatch = useDispatch()
  const [searchTerms, setSearchTerms] = useState('')
  const [getSavedConstituentsList, {data, loading, error}] = useSavedConstituents()
  const [removeFromList, {data: removeFromListData, loading: removeFromListLoading, error: removeFromListError}] =
    useDeleteConstituentFromSavedList()
  const getListName = useSelector((state) => state.campaignAction)
  const constituentsList = useSelector((state) => state.saveProspectList.value)
  const {actionName, name} = getListName
  const {searchTerm} = useSelector((state) => state.openSavedProspect.setAllConstituentsfilters)
  const showCheckboxes = prospectsActions.savedConstituentList.checkBoxRequired
  const showAddColumnHeader = prospectsActions.savedConstituentList.addColumnRequired
  const hasAccordian = prospectsActions.savedConstituentList.hasAccordian

  const [isActionRequired, setIsActionRequired] = useState(prospectsActions.savedConstituentList.hasActions)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)

  const selectedItemCurrentPageNumber = useSelector(
    (state) => state.currentPageNumber.allConstituentsSavedProspectsValue
  )

  const defaultHeaders = useSelector((state) => state.addColumnProspectsTable.defaultValue)

  const allProspectsColumns = useSelector((state) => state.addColumnProspectsTable.prospectListColumn)

  const [defaultColumns, setDefaultColumns] = useState(defaultHeaders)

  const [conditionalHeaders, {data: headersData, loading: loadingHeaders, error: errorLoadingHeaders}] =
    useUserPreferenceProspectsColumn()

  const searchString = useSelector((state) => state.search.savedProspectsSearch)
  const {previousTerm, currentTerm} = searchString

  const [confirmationPopup, setConfirmationPopup] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [open, setOpen] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const actionMenu = prospectsActions.savedConstituentList.actionsMenu
  const [rowData, setRowData] = useState()

  const [totalConstituentsCount, setTotalConstituentsCount] = useState()

  const refData = useSelector((state) => state.opportunityBank.refData)

  const exportError = useSelector((state) => state.exportList)

  useEffect(() => {
    dispatch(setSortColumn(null))
    dispatch(setSortDirection('asc'))
    dispatch(setSortConfig({direction: 'asc', key: null}))
    dispatch(setMessage(''))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (defaultHeaders?.length === 0) {
      conditionalHeaders()
    }
  }, [defaultHeaders, conditionalHeaders])

  useEffect(() => {
    if (headersData?.getUserPreferences != null && headersData.getUserPreferences[0]?.defaultColumns.length > 0) {
      dispatch(getDefaultColumns(headersData?.getUserPreferences[0]?.defaultColumns))
      setDefaultColumns(headersData?.getUserPreferences[0]?.defaultColumns)
    }
  }, [headersData, dispatch])

  const handleBack = () => {
    dispatch(setCampaignView('defaultView'))
    dispatch(setButtonViewName('Switch to manual view'))
    dispatch(setSwitchFilters(false))
    dispatch(selectedTab(`${SegmentProspects.segments.savedProspects.key}`))
    dispatch(constituentIdList([]))
    dispatch(setAllConstituentsSavedProspectsListPageNumber(1))
    if (currentTerm !== previousTerm) {
      dispatch(getAllSavedProspectsData([]))
      dispatch(getSavedProspectsPageNumber(1))
      dispatch(updatedSavedProspectsSearchTerm({currentTerm: '', previousTerm: ''}))
    }
    dispatch(setChatbotData([]))
    dispatch(setMessage(''))
    dispatch(setMatchedProspectId([]))
    dispatch(setInterestTagId([]))
    dispatch(setMatchedProspectList([]))
    dispatch(setFilters({}))
    dispatch(setSortColumn(null))
    dispatch(setSortDirection('asc'))
    dispatch(setSortConfig({direction: 'asc', key: null}))
  }

  useEffect(() => {
    if (
      !removeFromListData?.removeFromList?.removeFromList?.listName &&
      !removeFromListLoading &&
      !removeFromListError &&
      defaultHeaders.length > 0
    ) {
      getSavedConstituentsList()
    }
  }, [removeFromListData, getSavedConstituentsList, removeFromListLoading, removeFromListError, defaultHeaders])

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [setOpen])

  const handleConfirmation = useCallback(() => {
    setOpenAlert(false)
    removeFromList({
      variables: {
        listName: name,
        constituentId: constituentsList,
        ...(azureRole ? {azureRole} : {})
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeFromList, setOpenAlert, name, constituentsList])

  useEffect(() => {
    if (actionName === 'removeFromList') {
      handleOpen()
      handleConfirmation()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleOpen, actionName, removeFromList, data, handleConfirmation])

  function shouldUpdatePageNumber() {
    const isLastPage =
      selectedItemCurrentPageNumber >=
      Math.ceil(data?.savedProspectsOrAttendees?.totalCount / paginationLimit.pagination.savedConstituentsList)
    const allItemSelected = data?.savedProspectsOrAttendees?.prospects.length === constituentsList.length
    return isLastPage && allItemSelected && selectedItemCurrentPageNumber !== 1
  }

  useEffect(() => {
    if (removeFromListData) {
      dispatch(setCampaignAction({actionName: '', name: removeFromListData?.removeFromList?.removeFromList?.listName}))
      setIsActionRequired(prospectsActions.savedConstituentList.hasActions)
      setSelectAll(false)
      dispatch(constituentIdList([]))
      setTotalConstituentsCount(totalConstituentsCount - constituentsList.length)
      if (totalConstituentsCount - constituentsList.length > 0) {
        if (shouldUpdatePageNumber()) {
          dispatch(setAllConstituentsSavedProspectsListPageNumber(selectedItemCurrentPageNumber - 1))
        }
      }
      handleClose()
      getSavedConstituentsList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeFromListData, getSavedConstituentsList, dispatch])

  const handleSavedProspectsSearch = (searchTerm) => {
    setSearchTerms(searchTerm)
    setSelectAll(false)
    dispatch(setAllConstituentsSavedProspectsListPageNumber(1))
    dispatch(setAllConstituentsTotalCount(0))
    dispatch(
      setAllConstituentsFilters({
        // eslint-disable-next-line object-shorthand
        searchTerm: searchTerm
      })
    )
    getSavedConstituentsList()
  }

  useEffect(() => {
    if (data && data?.savedProspectsOrAttendees?.prospects?.length > 0 && !loading && !error) {
      const updatedRows = data?.savedProspectsOrAttendees?.prospects.map((row) => ({
        ...row,
        selected: constituentsList.includes(row.uniqueConstituentIdentifier),
        classYear: getClassYear(row.educationSummary),
        college: getUniqueCollegeAndDegree(row.educationSummary, 'college'),
        degree: getUniqueCollegeAndDegree(row.educationSummary, 'degree')
      }))
      setRowData(updatedRows)
      const allSelected = updatedRows.length > 0 && updatedRows.every((row) => row.selected)
      setSelectAll(allSelected)
      if (!searchTerm) {
        setTotalConstituentsCount(data?.savedProspectsOrAttendees.totalCount)
      }
      dispatch(setListDescription(data?.savedProspectsOrAttendees?.listEventDescription))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, data, loading, error, searchTerm])

  const handleClose = () => {
    setOpen(false)
  }

  const handleSelectAll = (event) => {
    dispatch(setCampaignAction({actionName: '', name}))
    const checked = event.target.checked
    const updatedRows = rowData?.map((row) => ({...row, selected: checked}))
    const currentPageIds = updatedRows.map((row) => row.uniqueConstituentIdentifier)
    const updatedList = checked
      ? [...new Set([...constituentsList, ...currentPageIds])]
      : constituentsList.filter((id) => !currentPageIds.includes(id))
    dispatch(constituentIdList(updatedList))
    setSelectAll(checked)
    setRowData(updatedRows)
    setIsActionRequired(!checked)
  }

  const handleRowCheckboxChange = (event, obj) => {
    dispatch(setCampaignAction({actionName: '', name}))
    const checked = event.target.checked
    const updatedRows = rowData.map((row) =>
      row.uniqueConstituentIdentifier === obj.uniqueConstituentIdentifier ? {...row, selected: checked} : row
    )
    setRowData(updatedRows)
    const allSelected = updatedRows.every((row) => row.selected)
    const anySelected = updatedRows.some((row) => row.selected)
    setSelectAll(allSelected)
    setIsActionRequired(!anySelected)
    const updatedList = checked
      ? [...new Set([...constituentsList, obj.uniqueConstituentIdentifier])]
      : constituentsList.filter((id) => id !== obj.uniqueConstituentIdentifier)
    dispatch(constituentIdList(updatedList))
  }

  const handleChangePage = (event, newValue) => {
    if (newValue !== selectedItemCurrentPageNumber) {
      setSelectAll(false)
      dispatch(setAllConstituentsSavedProspectsListPageNumber(newValue))
      getSavedConstituentsList()
    }
  }

  const handleRemoveFromList = () => {
    dispatch(setCampaignAction({actionName: '', name}))
    handleOpen()
    handleConfirmation()
  }

  const handleConfirmationClose = () => {
    setConfirmationPopup(false)
  }

  const handleAlertClose = () => {
    setOpenAlert(false)
  }

  useEffect(() => {
    if (removeFromListError && !removeFromListLoading && !confirmationPopup) {
      setOpenAlert(true)
      setOpen(false)
    }
    if (removeFromListLoading && !removeFromListError && confirmationPopup) {
      setOpenAlert(false)
    }
  }, [removeFromListError, removeFromListLoading, confirmationPopup])

  const handleTableRowClick = (event) => {
    event.stopPropagation()
  }

  const handleSort = () => {
    getSavedConstituentsList()
  }

  const deselectAll = () => {
    setSelectAll(false)
    const updatedRows = rowData?.map((row) => ({...row, selected: false}))
    setRowData(updatedRows)
    dispatch(constituentIdList([]))
    setIsActionRequired(true)
  }

  const handleExportErrorClose = () => {
    dispatch(clearExportError())
  }

  const handleExportingInfoClose = () => {
    dispatch(hideExportingInfo())
  }

  return (
    <StyledDiv>
      <StyledBackdrop open={open}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
      <StyledDivContainer>
        <StyledBackButton onClick={handleBack}>{'<< Back to Prospects List'}</StyledBackButton>
        <>
          <StyledSnackbar
            sx={{marginRight: '-16px'}}
            open={exportError.showExportingInfo}
            onClose={(event, reason) => {
              if (reason === 'clickaway') return
              handleExportingInfoClose()
            }}
          >
            <StyledAlertSnackbar severity="info" onClose={handleExportingInfoClose}>
              Your file is being exported
            </StyledAlertSnackbar>
          </StyledSnackbar>

          <StyledSnackbar
            sx={{marginRight: '-16px'}}
            open={exportError.showError}
            onClose={(event, reason) => {
              if (reason === 'clickaway') return
              handleExportErrorClose()
            }}
          >
            <StyledAlertSnackbar severity="error" onClose={handleExportErrorClose}>
              {exportError.errorMessage}
            </StyledAlertSnackbar>
          </StyledSnackbar>

          <StyledSnackbar
            sx={{marginRight: '-16px'}}
            open={exportError.showSuccess}
            onClose={(event, reason) => {
              if (reason === 'clickaway') return
              handleExportErrorClose()
            }}
          >
            <StyledAlertSnackbar severity="success" onClose={handleExportErrorClose}>
              Your file has been successfully exported
            </StyledAlertSnackbar>
          </StyledSnackbar>
        </>
      </StyledDivContainer>
      <StyledGrid container>
        <Grid item>
          <Title title={name} />
        </Grid>
        {openAlert && (
          <StyledAlertGrid item>
            <AlertErrorComponent
              handleAlertClose={handleAlertClose}
              title={'Error occurred while removing prospect from list.'}
              searchTerm={searchTerms}
            />
          </StyledAlertGrid>
        )}
      </StyledGrid>
      <StyledBox>
        <SearchPanel
          width="35%"
          aria-label="search-for-a-user"
          data-testid="search-panel"
          setSearchTerm={handleSavedProspectsSearch}
          placeholder="Search for a name"
        />
        {constituentsList.length > 0 && (
          <StyledSaveAndGenerateButton
            variant="outlined"
            onClick={deselectAll}
            disabled={!constituentsList.length || loading}
          >
            {`Deselect (${constituentsList.length})`}
          </StyledSaveAndGenerateButton>
        )}
        <StyledSaveAndGenerateButton onClick={handleRemoveFromList} disabled={!constituentsList.length || loading}>
          {constituentsList.length ? `Remove (${constituentsList.length}) from list` : `Remove from list`}
        </StyledSaveAndGenerateButton>
        <ExportListIndex
          searchTerm={searchTerm}
          disableExport={loading || error || loadingHeaders || errorLoadingHeaders}
          listName={name}
          count={data?.savedProspectsOrAttendees?.totalCount ?? 0}
          constituentsList={constituentsList}
          documentName={`${name}_${new Date().toISOString()}`}
        />
      </StyledBox>
      <TableComponent
        loading={loading || loadingHeaders}
        error={error || errorLoadingHeaders}
        headers={defaultColumns}
        explicitKeyLabelMapping={headers.explicitKeyLabelMapping}
        data={data?.savedProspectsOrAttendees?.prospects}
        totalCount={data?.savedProspectsOrAttendees?.totalCount}
        handleChangePage={handleChangePage}
        showCheckboxes={showCheckboxes}
        showAddColumnHeader={showAddColumnHeader}
        selectedItemCurrentPageNumber={selectedItemCurrentPageNumber}
        hasAccordian={hasAccordian}
        isActionRequired={isActionRequired}
        handleSelectAll={handleSelectAll}
        handleRowCheckboxChange={handleRowCheckboxChange}
        rowData={rowData}
        setRowData={setRowData}
        selectAll={selectAll}
        actionMenuList={actionMenu}
        rows={paginationLimit.pagination.savedConstituentsList}
        handleTableRowClick={handleTableRowClick}
        statesValue={refData?.find((item) => item.filter === 'state')?.valuesWithId || []}
        excludedSorting={headers.excludedSorting}
        addColumnComponent={
          <AddColumn
            columns={allProspectsColumns}
            currentHeaders={defaultColumns}
            handleMenuItemClick={(data) => {
              setDefaultColumns(data)
            }}
          />
        }
        handleDataSort={handleSort}
      />
      {confirmationPopup && (
        <ConfirmationPopup
          confirmationPopup={confirmationPopup}
          handleConfirmationClose={handleConfirmationClose}
          handleConfirmation={handleConfirmation}
          loading={removeFromListLoading}
          errorMessage={removeFromListError}
          name={name}
        ></ConfirmationPopup>
      )}
    </StyledDiv>
  )
}

export default AllConstituents
